import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-calibrant-footer',
    templateUrl: './calibrant-footer.component.html',
    styleUrls: ['./calibrant-footer.component.css'],
    standalone: false
})
export class CalibrantFooterComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }
}
